(function () {
  function getClampLines() {
    return window.matchMedia('(max-width: 640px)').matches ? 10 : 12;
  }

  function getLineHeight(el) {
    var lh = parseFloat(window.getComputedStyle(el).lineHeight);
    if (!lh || Number.isNaN(lh)) {
      lh = parseFloat(window.getComputedStyle(el).fontSize) * 1.75;
    }
    return lh;
  }

  function lockPageScroll() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('tm-desc-scroll-lock');
    document.body.classList.add('tm-desc-scroll-lock');
    document.body.style.top = '-' + scrollY + 'px';
    return scrollY;
  }

  function unlockPageScroll(scrollY) {
    document.documentElement.classList.remove('tm-desc-scroll-lock');
    document.body.classList.remove('tm-desc-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function initDescription(root) {
    var body = root.querySelector('.tm-desc__body');
    var btn = root.querySelector('.tm-desc__btn');
    if (!body || !btn) return;

    var clampHeight = getLineHeight(body) * getClampLines();

    body.classList.add('tm-desc__clamp');
    body.style.maxHeight = clampHeight + 'px';
    body.dataset.clampHeight = String(clampHeight);

    requestAnimationFrame(function () {
      if (body.scrollHeight <= clampHeight + 8) {
        btn.hidden = true;
        body.classList.remove('tm-desc__clamp');
        body.style.maxHeight = '';
        return;
      }
      btn.hidden = false;
    });

    btn.addEventListener('click', function (e) {
      e.preventDefault();

      var expanded = body.classList.contains('tm-desc__clamp');
      var scrollY = lockPageScroll();

      if (expanded) {
        var fullHeight = body.scrollHeight;
        body.classList.remove('tm-desc__clamp');
        body.style.maxHeight = fullHeight + 'px';
        body.style.overflow = 'visible';
        btn.textContent = 'Kapat';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        body.classList.add('tm-desc__clamp');
        body.style.overflow = '';
        body.style.maxHeight = body.dataset.clampHeight + 'px';
        btn.textContent = 'Devamını oku';
        btn.setAttribute('aria-expanded', 'false');
      }

      btn.blur();
      unlockPageScroll(scrollY);
    });
  }

  function boot() {
    document.querySelectorAll('.tm-desc').forEach(initDescription);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
